import { Document } from '@/types/document';
import { DocumentCard } from './DocumentCard';
import { EmptyState } from '@/components/common/EmptyState';
import { FileText } from 'lucide-react';
import { Skeleton } from '@/components/ui/skeleton';

interface DocumentListProps {
  documents: Document[];
  isLoading?: boolean;
  onView?: (doc: Document) => void;
  onDownload?: (doc: Document) => void;
  onDelete?: (doc: Document) => void;
  showUser?: boolean;
  emptyTitle?: string;
  emptyDescription?: string;
  emptyAction?: {
    label: string;
    onClick: () => void;
  };
}

export function DocumentList({
  documents,
  isLoading = false,
  onView,
  onDownload,
  onDelete,
  showUser = false,
  emptyTitle = 'No documents found',
  emptyDescription = 'There are no documents to display.',
  emptyAction,
}: DocumentListProps) {
  if (isLoading) {
    return (
      <div className="space-y-3">
        {[...Array(5)].map((_, i) => (
          <Skeleton key={i} className="h-20" />
        ))}
      </div>
    );
  }

  if (documents.length === 0) {
    return (
      <EmptyState
        icon={FileText}
        title={emptyTitle}
        description={emptyDescription}
        action={emptyAction}
      />
    );
  }

  return (
    <div className="space-y-3">
      {documents.map((doc) => (
        <DocumentCard
          key={doc.id}
          document={doc}
          onView={onView}
          onDownload={onDownload}
          onDelete={onDelete}
          showUser={showUser}
        />
      ))}
    </div>
  );
}
